import originJsonp from 'jsonp'
import axios from 'axios'
import qs from 'qs'
import { ElMessage as message } from 'element-plus'
import { getCookie, handleLogout, getAddressUrlParamInfo } from './utils'

axios.defaults.headers = {
  'Content-Type': 'application/x-www-form-urlencoded'
}

// 不需要携带cookie接口地址
const apiUrl = [
  'fteaching.zhihuishu.com',
  'hike-shared-library',
  'oauth.zhihuishu.com',
  'paytest-v5.axinfu.com:8081',
  'schlzyxy.zhihuianxin.net:19816',
  'hike-teaching.zhihuishu.com',
  'hike-teaching-api.zhihuishu.com'
]

// 根据请求地址获取加密的key
const idMaps = {
  14: [
    'hike-teaching-center-gateway.polymas.com',
    'hike-teaching.zhihuishu.com',
    'hike-live.zhihuishu.com',
    'aidedteachingdata.zhihuishu.com',
    'aidedteachingdata-api.zhihuishu.com',
    'ctapp.zhihuishu.com',
    'hike-teaching-api.zhihuishu.com'
  ],
  1: ['user.zhihuishu.com'],
  13: [],
  5: ['question-api.zhihuishu.com']
}

function getSecretId(url) {
  let flag
  for (let id in idMaps) {
    flag = idMaps[id].some(item => {
      return url.includes(item)
    })
    if (flag) return id
  }
}

function needSecret(url) {
  return url.includes('gateway/f') || url.includes('gateway/t')
}

const getExamK = url => {
  const moudleType = getSecretId(url)
  return window.labc(moudleType).then(key => key)
}

let headerToken = 'X-Access-Token'
//POST传参序列化
axios.interceptors.request.use(
  async config => {
    if (config.method === 'post') {
      if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        config.data = qs.stringify(config.data)
      }
    }
    if (config.custom) {
      config.headers = {
        'Content-Type': config.custom.headers['Content-Type']
      }
    }
    if (config.headers['Content-Type'] === 'application/json') {
      config.data = qs.parse(config.data)
    }
    if (needSecret(config.url)) {
      let key
      try {
        key = await getExamK(config.url)
      } catch (e) {
        console.log('e :>> ', e)
      }
      if (Object.keys(getAddressUrlParamInfo(config.url)).length) {
        config.params = { secretStr: window.yxyz(getAddressUrlParamInfo(config.url), key) }
        config.url = config.url.split('?')[0]
      }
    //   if (config.data) {
    //     console.log(`${config.url} 加密前参数  ::>> `, config.data)
    //     config.data = { secretStr: window.yxyz(config.data, key), date: new Date().getTime() }
    //   }
    //   if (config.params) {
    //     console.log(`${config.url} 加密前参数  ::>> `, config.params)
    //     config.params = { secretStr: window.yxyz(config.params, key), date: new Date().getTime() }
    //   }
    }

    if (getCookie(headerToken)) {
      const result = apiUrl.some(item => config.url.includes(item))
      if (!result) {
        config.headers[headerToken] = getCookie(headerToken)
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

//返回状态判断
axios.interceptors.response.use(
  res => {
    if (res.data.code == 10002) {
      message.error('未登录或登录过期，请重新登录')
      handleLogout()
      return
    }
    if ((res.data.status && res.data.status == 200) || res.data.code == 200) {
      return Promise.resolve(res)
    } else {
      return Promise.reject(res)
    }
  },
  error => {
    return Promise.reject(error)
  }
)
export function getFetch(url, params = {}) {
  return axios.get(url, { params }).then(
    res => {
      if ((res.data.status && res.data.status == 200) || res.data.code == 200) {
        return Promise.resolve(res.data.rt || res.data.data)
      }
      return Promise.reject(res.data)
    },
    error => {
      // console.log("+-----------------------",error);
      message.error(error.message || error.data.msg || error.data.message)
      // message.error('网络错误，请稍后重试');
      return Promise.reject(error)
    }
  )
}
export function postFetch(...args) {
  return axios.post(...args).then(
    res => {
      if ((res.data.status && res.data.status == 200) || res.data.code == 200) {
        return Promise.resolve(res.data.rt || res.data.data)
      }
      return Promise.reject(res.data)
    },
    error => {
      message.error(error.message || error.data.message || error.data.msg)
      // message.error('网络错误，请稍后重试');
      return Promise.reject(error)
    }
  )
}
export function jsonp(url, params = {}, option) {
  return new Promise((resolve, reject) => {
    let finalUrl = url + (url.indexOf('?') < 0 ? '?' : '&') + qs.stringify(params)
    originJsonp(finalUrl, { param: 'callback', ...option }, (err, data) => {
      if (!err) {
        if (data.currentTime) {
          window.currentTime = data.currentTime
        }
        if (data && data.status === '200') {
          resolve(data.rt) //请求成功
        } else {
          reject(data.msg)
        }
      } else {
        reject(err) //失败
      }
    })
  })
}
